import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfiguration } from '../../core/models/app-configuration.model';
import { ComunicationSetting } from '../model/comunication-setting.model';
import { map } from 'rxjs/operators';

/**
 * Comunication Setting Service
 * @description Angular service used for retrieve and update comunication service
 */
@Injectable({ providedIn: 'root' })
export class ComunicationSettingService {
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfiguration) { }

  getResourceUrl(): string {
    return this.appConfig.serverApiUrl + '/api/v1/comunicationsetting';
  }

  updateComunicationSetting(req: ComunicationSetting): Observable<ComunicationSetting> {
    return this.http.post<ComunicationSetting>(this.getResourceUrl() + '/set', req);
  }

  getComunicationSetting(): Observable<ComunicationSetting> {
    return this.http.post<ComunicationSetting>(this.getResourceUrl() + '/get', { observe: 'response' });
  }

  getSalesChanel(): Observable<string> {
    return this.http.get<{ salesChannel: string }>(`${this.getResourceUrl()}/saleschannel`).pipe(map((selChanel: { salesChannel: string }) => selChanel.salesChannel));
  }
}
